import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

// DEPRECATED: Starting with v4 of styled-components, the api has changed
// to use the default `ref` instead of `innerRef` which renders this useless.
// This should be removed after all calls to it have been removed from all projects.
// What has been done:
// - g4mobile

export class InputWrapper extends PureComponent {
  static propTypes = {
    /** all component children nodes */
    children: PropTypes.node,
  };
  constructor(props) {
    super(props);

    this.assignInnerRef = this.assignInnerRef.bind(this);
  }

  assignInnerRef(input) {
    if (input && input.el) {
      this.el = input.el;
    }
  }

  render() {
    const { children, ...rest } = this.props;
    return React.cloneElement(React.Children.only(children), {
      ...rest,
      innerRef: this.assignInnerRef,
    });
  }
}

export default inputElement =>
  React.createElement(InputWrapper, inputElement.props, inputElement);
